import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import BarcodeProps from './BarcodeProps'

import Border from './Border'
import Padding from './Padding'
import Text from './Text'

export default {
    props: BarcodeProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Border,
        Padding,
        Text
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoBarcode(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoBarcode()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoBarcode/KendoBarcodeMixin.js